<div class="app-documents-list-item mat-elevation-z2">
  <div class="name">
    @if (document.file.url) {
    <button class="file-link" data-action="download" (click)="onDownload()">
      {{ document.file.name }}
    </button>
    } @else {
    {{ document.file.name }}
    }
  </div>
  <div class="actions">
    @if(document.file.url) {
    <button mat-icon-button data-action="download" (click)="onDownload()">
      <mat-icon>download</mat-icon>
    </button>
    }
  </div>
</div>
